var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41107 6.91058C9.73651 6.58514 10.2641 6.58514 10.5896 6.91058L15.5896 11.9106C15.915 12.236 15.915 12.7637 15.5896 13.0891C15.2641 13.4145 14.7365 13.4145 14.4111 13.0891L10.0003 8.67835L5.58958 13.0891C5.26414 13.4145 4.73651 13.4145 4.41107 13.0891C4.08563 12.7637 4.08563 12.236 4.41107 11.9106L9.41107 6.91058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp0);
export default __webpack_public_path__ + "static/media/chevron-up0.63b0a8fd9e09973a418dddb1490b3a65.svg";
export { ForwardRef as ReactComponent };